import { openDoor } from "../../../../Redux/Bookings/BookingsActions";
import { AppDispatch } from "../../../../Redux/store";
import styles from "./DoorSelectorModal.module.scss";
import Modal from "../../../Common/Modal/Modal";
import { FaUnlockAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";

interface Amenity {
  amenityId: number;
  name: string;
  image: string;
  isActive: boolean;
  lastVisited: string | null;
  amenityTypeName: string;
  isBookableSlot: boolean;
  maxhours: number;
  doors: AmenityDoor[];
  amenitySlots: AmenitySlot[];
}

interface AmenityDoor {
  id: number;
  doorName: string;
  doorId: number;
  panelId: number;
  amenityId: number;
}

interface AmenitySlot {
  amenityId: number;
  endDate: string;
  id: number;
  memberId: number;
  startDate: string;
}

interface Props {
  amenity: Amenity;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function DoorSelectorModal(props: Props) {
  const { amenity, isOpen, setIsOpen } = props;
  const dispatch = useDispatch<AppDispatch>();

  const openDoorHandler = (door: AmenityDoor) => {
    dispatch(
      openDoor({
        amenityId: amenity.amenityId.toString(),
        doorId: door.id.toString(),
      }),
    );
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={styles.mainContainer}>
        <div className={styles.headerContainer}>
          <p className={styles.headerTitle}>Select a door</p>
          <p className={styles.headerSubtitle}>
            Choose which door you want to unlock for {amenity?.name}
          </p>
        </div>

        <div className={styles.doorAmenityContainer}>
          <div className={styles.amenityContainer}>
            <div className={styles.amenityImageContainer}>
              <img
                className={styles.amenityImage}
                src={amenity?.image}
                alt={amenity?.name}
              />
            </div>
            <div className={styles.amenityInfo}>
              <p className={styles.amenityName}>{amenity?.name}</p>
              <p className={styles.amenityType}>{amenity?.amenityTypeName}</p>
            </div>
          </div>

          <div className={styles.doorsContainer}>
            {amenity?.doors?.length > 0 ? (
              <div className={styles.doorsList}>
                {amenity.doors.map((door) => (
                  <button
                    key={door.id}
                    type="button"
                    className={styles.doorItem}
                    onClick={() => openDoorHandler(door)}
                  >
                    <div className={styles.doorInfo}>
                      <p className={styles.doorName}>{door.doorName}</p>
                      <p className={styles.doorMeta}>Tap to unlock this door</p>
                    </div>
                    <div className={styles.doorAction}>
                      <FaUnlockAlt className={styles.unlockIcon} />
                    </div>
                  </button>
                ))}
              </div>
            ) : (
              <div className={styles.emptyState}>
                <p className={styles.emptyTitle}>No doors available</p>
                <p className={styles.emptyText}>
                  This amenity does not have any doors configured yet.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DoorSelectorModal;
